import Vue from 'vue'
import App from './App.vue'
import vuetify from "./plugins/vuetify"
import VueCookie from 'vue-cookie'
import axios from 'axios'
import eventBus from './plugins/event-bus'
import {store} from './plugins/vuex'
import {injectBaseURLsToPrototype} from "./plugins/consts"
import {injectAxiosRequestInterceptor, injectAxiosResponseInterceptor} from "./plugins/axios/interceptors"
import {vMaska} from "maska"
import 'overlayscrollbars/styles/overlayscrollbars.css'

Vue.prototype.$eventBus = eventBus

Vue.use(VueCookie)
Vue.directive('maska', vMaska)

injectBaseURLsToPrototype(Vue.prototype)

Vue.config.productionTip = false

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios

const root = new Vue({
  vuetify,
  render: h => h(App),
  store,
}).$mount('#app')

injectAxiosRequestInterceptor(axios, root)
injectAxiosResponseInterceptor(axios, root)